import { render, staticRenderFns } from "./Cancel.vue?vue&type=template&id=2da8124a&scoped=true&"
import script from "./Cancel.vue?vue&type=script&setup=true&lang=js&"
export * from "./Cancel.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Cancel.vue?vue&type=style&index=0&id=2da8124a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da8124a",
  null
  
)

export default component.exports